import getConfig from 'next/config';
import { useEffect, useState } from 'react';
import { handleTrack } from '../../../../utils/tracker';
import {
  getCryptoData,
  getStocksData,
  setITRLocalStorage,
} from '../../../itr2/static/utils';
import CryptoPageAPIS from '../../itr2.service';
import { cryptoIntegrationLink } from '../../static/data';
import { BrokerListWrapper } from './BrokerListWrapper';
import { STOCKS_DATA } from './stocks-data';
const { publicRuntimeConfig } = getConfig();

interface BROKER_LIST_PROPS {
  searchKey?: string;
  pageType?: string;
  exchangeFilter?: string;
}
export const BrokerList = ({
  searchKey = '',
  pageType = 'brokers',
  exchangeFilter = 'all',
}: BROKER_LIST_PROPS): JSX.Element => {
  const [BrokerData, setBrokerData] = useState([
    {
      brokerDetails: {
        name: '',
        type: '',
        logoUrl:
          'https://assets1.cleartax-cdn.com/cleartax/images/1644906212_clearfavicon.png',
      },
      brokerId: '',
    },
  ]);

  useEffect(() => {
    const getBrokers = async () => {
      try {
        const rawResponse = await CryptoPageAPIS.getBokers();
        const response = await rawResponse.data;
        setBrokerData([...response]);
      } catch (e) {
        console.log(e);
      }
    };
    getBrokers();
  }, []);

  const handleRedirect = (
    id: string,
    isCryptoLogin: boolean,
    isForeignPartner: boolean
  ) => {
    handleTrack({ label: `${id}_button` });
    const filingLink = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing/2023/0/cg/dashboard`;
    const filingQueryParam = `?PT=MP&BI=${id}&FP=${isForeignPartner}`;
    setITRLocalStorage(
      isCryptoLogin ? cryptoIntegrationLink : filingLink + filingQueryParam
    );

    window.open(isCryptoLogin ? cryptoIntegrationLink : filingLink);
  };

  const cryptoData = getCryptoData(BrokerData, searchKey, exchangeFilter);
  const stocksData = getStocksData(STOCKS_DATA, searchKey, exchangeFilter);

  if (cryptoData.length === 0 && stocksData.length === 0) return <></>;

  return (
    <div
      className={`grid ${
        pageType === 'drawer' ? 'grid-cols-4' : 'grid-cols-8'
      } md:grid-cols-5 sm:grid-cols-3 xs:grid-cols-2 gap-4 mb-12`}
      data-testid="broker"
    >
      <>
        <BrokerListWrapper
          data={stocksData}
          handleRedirect={handleRedirect}
          isCryptoLogin={false}
        />
        <BrokerListWrapper
          data={cryptoData}
          handleRedirect={handleRedirect}
          isCryptoLogin={true}
        />
      </>
    </div>
  );
};
